/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Card, Stack, Tab, Typography, Box } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import CustomTabPanel from './TabPanel';
import { useParams } from 'react-router-dom';
import { CheckboxContent } from 'screen/summary/components/ItemContent';
import { buildSexValue, getSexSelfDescribeValue } from 'screen/summary/PersonalSum';
import {
  checkEnableParseJSON,
  formatDate,
  renderDate,
  formatBoolean,
  formatBooleanToYesNo,
  capitalizeFirstLetter,
  tryParseJSON,
} from 'components/helper/helper';
// import { Button, Col, Row } from 'react-bootstrap';
import basicInformationServices from 'services/basicInformationApi';
import LoadingContent from 'components/LoadingContent';
import { militaryOptions } from 'screen/personal/demographics/Demographics';
import EthnicitySum from 'screen/summary/components/EthnicitySum';
import { getEducationalProgram } from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import { useAppSelector, useAppDispatch } from 'app/hooks';
// import { ModalCheckField } from 'screen/common/ModalCheckField';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
// import GMTabs, { createPersonalInfoTabs } from 'components/shared/GMTabs';
import 'styles/tabs.scss';
import { usePageStatus } from 'hooks/usePageStatus';
import { toggleCounselorReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';
import { getUserRole } from 'utils/sessionStorage';

export const moduleName: any = {
  '1.1': 'Basic Info & Contact',
  '1.2': 'Demographics',
  '1.3': 'Citizenship',
  '1.4': 'Educational Programs Participation',
  '1.5': 'Other Information',
  '2.1': 'Household',
  '2.2': 'Parent 1',
  '2.3': 'Parent 2',
  '2.4': 'Siblings',
  '3.1': 'High Schools',
  '3.2': 'Colleges & Universities',
  '3.3': 'Future Plans',
  '4.1': 'General',
  '4.2': 'SAT & ACT',
  '4.3': 'AP Tests',
  '4.4': 'IB Tests',
  '4.5': 'CLEP Tests',
  '5.1': 'General',
  '5.2': '9th',
  '5.3': '10th',
  '5.4': '11th',
  '5.5': '12th',
  '5.6': 'College Courses',
  '5.7': 'A-G Summary',
  '5.8': 'W Course Summary',
  '6.1': 'Activities 1-10',
  '6.2': 'Honors & Awards',
  '6.3': 'EOP and Other Info',
  '6.6': 'Activities 20+',
  '6.5': 'Activities 11-20',
  '7.1': 'General',
  '7.2': 'Common App',
  '7.3': 'UC App',
  '8.1': 'College Search',
  '8.2': 'College List',
  '9.1': 'GPA Forecaster',
};

export const moduleLink: any = {
  '1.1': window.location.origin + '/#/application/summary/personal/',
  '1.2': window.location.origin + '/#/application/summary/personal/',
  '1.3': window.location.origin + '/#/application/summary/personal/',
  '1.4': window.location.origin + '/#/application/summary/personal/',
  '1.5': window.location.origin + '/#/application/summary/personal/',
  '2.1': window.location.origin + '/#/application/summary/family/',
  '2.2': window.location.origin + '/#/application/summary/family/',
  '2.3': window.location.origin + '/#/application/summary/family/',
  '2.4': window.location.origin + '/#/application/summary/family/',
  '3.1': window.location.origin + '/#/application/summary/education/',
  '3.2': window.location.origin + '/#/application/summary/education/',
  '3.3': window.location.origin + '/#/application/summary/education/',
  '4.1': window.location.origin + '/#/application/summary/test/',
  '4.2': window.location.origin + '/#/application/summary/test/',
  '4.3': window.location.origin + '/#/application/summary/test/',
  '4.4': window.location.origin + '/#/application/summary/test/',
  '4.5': window.location.origin + '/#/application/summary/test/',
  '5.1': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.2': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.3': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.4': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.5': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.6': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.7': window.location.origin + '/#/application/summary/course-and-grade/',
  '5.8': window.location.origin + '/#/application/summary/course-and-grade/',
  '6.1': window.location.origin + '/#/application/summary/activities-and-honors/',
  '6.2': window.location.origin + '/#/application/summary/activities-and-honors/',
  '6.3': window.location.origin + '/#/application/summary/activities-and-honors/',
  '6.6': window.location.origin + '/#/application/summary/activities-and-honors/',
  '6.5': window.location.origin + '/#/application/summary/activities-and-honors/',
  '7.1': window.location.origin + '/#/application/summary/additional/',
  '7.2': window.location.origin + '/#/application/summary/additional/',
  '7.3': window.location.origin + '/#/application/summary/additional/',
  '8.1': window.location.origin + '/#/application/college-search',
  '8.2': window.location.origin + '/#/application/college-search',
  '9.1': window.location.origin + '/#/application/summary/GPAForecasterSum',
};

export const agSubjectTotals: any = {
  A: 'History / Social Science (2 Years)',
  B: 'English (4 Years)',
  C: 'Mathematics (3 Years)',
  D1: 'Biological Science (1 Year)',
  D2: 'Physical Science (1 Year)',
  E: 'Language Other Than English (2 Years)',
  F: 'Visual & Performing Arts (1 Year)',
  G: 'College-Preparatory Elective (1 Year)',
};

export const wCourseSummary: any = {
  WH: 'Weighted Honors Courses',
  AP: 'AP - Advanced Placement Courses',
  IB: 'IB - International Baccalaureate Courses',
  TC: 'Transferable College Courses',
};

type Props = {
  setCurrentModuleId: (id: string) => void;
  isCounselor?: boolean;
};

export const buildClassName = (moduleName: string, checkModule: any) => {
  let classNameResult = '';

  if (checkModule?.[moduleName]?.[0]) {
    classNameResult = classNameResult + ' student-checked';
  }
  if (checkModule?.[moduleName]?.[1]) {
    classNameResult = classNameResult + ' counselor-checked';
  }
  return classNameResult;
};

/**
 * Trạng thái tab con (student-checked / counselor-checked).
 * Dùng .some() giống tab cha để tránh lệch khi có nhiều bản ghi cùng page_name.
 * Truyền mảng page_name khi một nhãn tab gộp nhiều trang (vd: Basic Info & Contact = Basic + Contact).
 */
export const buildPageStatusClassName = (pageStatus: any, pageNameOrNames: string | string[]) => {
  if (!pageStatus?.length) {
    return '';
  }
  const names = Array.isArray(pageNameOrNames) ? pageNameOrNames : [pageNameOrNames];
  const allStudent = names.every((pageName) =>
    pageStatus.some((item: any) => item.page_name === pageName && item.student_completed)
  );
  const allCounselor = names.every((pageName) =>
    pageStatus.some((item: any) => item.page_name === pageName && item.counselor_verified)
  );
  let classNameResult = '';
  if (allStudent) {
    classNameResult = classNameResult + ' student-checked';
  }
  if (allCounselor) {
    classNameResult = classNameResult + ' counselor-checked';
  }
  return classNameResult;
};

/** Parent tab: same classes as child tabs when every required page has student_completed and/or counselor_verified. */
export const buildParentTabPageStatusClassName = (
  pageStatus: any[] | undefined,
  requiredPages: string[]
) => {
  if (!pageStatus?.length || !requiredPages.length) {
    return '';
  }
  const allStudent = requiredPages.every((pageName) =>
    pageStatus.some((item: any) => item.page_name === pageName && item.student_completed)
  );
  const allCounselor = requiredPages.every((pageName) =>
    pageStatus.some((item: any) => item.page_name === pageName && item.counselor_verified)
  );
  let classNameResult = '';
  if (allStudent) {
    classNameResult = classNameResult + ' student-checked';
  }
  if (allCounselor) {
    classNameResult = classNameResult + ' counselor-checked';
  }
  return classNameResult;
};

// const RPersonalInformation = ({ setCurrentModuleId, isCounselor }: Props) => {
//   const [value, setValue] = React.useState(1);
//   const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
//   const handleChange = (event: React.SyntheticEvent, newValue: number) => {
//     setValue(newValue);
//     setCurrentModuleId(`1.${newValue}`);
//   };
//   const [showModalCheck, setShowModelCheck] = React.useState(false);

//   const handleCloseModalCheck = () => {
//     setShowModelCheck(false);
//   };

//   return (
//     <div className="gm-counselor-review">
//       <ScrollableTabs>
//         <CustomTabPanel value={value} index={1}>
//           <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
//             <div className="d-flex justify-content-between mb-4">
//               <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
//                 Basic Info & Contact
//               </Typography>
//               <div>
//                 {localStorage.getItem('userRole') === USER_ROLE.student && (
//                   <Button
//                     variant="primary"
//                     className="p-2 px-3"
//                     onClick={() => setShowModelCheck(true)}
//                   >
//                     Check missing values
//                   </Button>
//                 )}
//               </div>
//             </div>
//             <Stack justifyContent={'center'} alignItems={'center'}>
//               <SummaryBasicInfo
//                 show={showModalCheck}
//                 handleCloseModalCheck={handleCloseModalCheck}
//               />
//             </Stack>
//           </Card>
//         </CustomTabPanel>
//         <CustomTabPanel value={value} index={2}>
//           <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
//             <Stack justifyContent={'center'} alignItems={'center'}>
//               <SummaryDemographics />
//             </Stack>
//           </Card>
//         </CustomTabPanel>
//         <CustomTabPanel value={value} index={3}>
//           <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
//             <Stack justifyContent={'center'} alignItems={'center'}>
//               <SummaryCitizenship />
//             </Stack>
//           </Card>
//         </CustomTabPanel>
//         <CustomTabPanel value={value} index={4}>
//           <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
//             <Stack justifyContent={'center'} alignItems={'center'}>
//               <SummaryCBO />
//             </Stack>
//           </Card>
//         </CustomTabPanel>
//         <CustomTabPanel value={value} index={5}>
//           <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
//             <Stack justifyContent={'center'} alignItems={'center'}>
//               <SummaryOther />
//             </Stack>
//           </Card>
//         </CustomTabPanel>
//       </ScrollableTabs>
//     </div>
//   );
// };

const RPersonalInformation = ({ setCurrentModuleId, isCounselor }: Props) => {
  const [value, setValue] = React.useState(1);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const params: { id?: string | number } = useParams();
  const studentId = params.id === ':id' ? null : params.id;
  
  // Use the custom hook for page status
  const { pageStatus } = usePageStatus({ studentId: studentId || '' });

  // const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`1.${newValue}`);
  };
  const [showModalCheck, setShowModelCheck] = React.useState(false);

  React.useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, [window.innerWidth]);


  const handleCloseModalCheck = () => {
    setShowModelCheck(false);
  };

  return (
    <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
      <ScrollableTabs
        className="mt-2"
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab
          value={1}
          label="Basic Info & Contact"
          // className={buildClassName('1.1', checkModule)}
          className={buildPageStatusClassName(pageStatus, [
            PAGE_NAME.BASIC_INFORMATION,
            PAGE_NAME.CONTACT_DETAILS,
          ])}
        />
        <Tab
          value={2}
          label="Demographics"
          // className={buildClassName('1.2', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.DEMOGRAPHICS)}
        />
        <Tab
          value={3}
          label="Citizenship/Residency"
          // className={buildClassName('1.3', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.CITIZENSHIP)}
        />
        <Tab
          value={4}
          label="CBOs & Fee Waiver"
          // className={buildClassName('1.4', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.CBO)}
        />
        <Tab
          value={5}
          label="Other Information"
          // className={buildClassName('1.5', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.OTHER)}
        />
      </ScrollableTabs>
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <div className="d-flex justify-content-between mb-4">
            <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
              Basic Info & Contact
            </Typography>
            <div>
              {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
                <Button
                  variant="primary"
                  className="p-2 px-3"
                  onClick={() => setShowModelCheck(true)}
                >
                  Check missing values
                </Button>
              )} */}
            </div>
          </div>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryBasicInfo
              show={showModalCheck}
              handleCloseModalCheck={handleCloseModalCheck}
              isMobile={isMobile}
            />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryDemographics isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryCitizenship isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryCBO isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryOther isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      </div>
    </div>
  );
};

export default RPersonalInformation;

export const SummaryBasicInfo = ({
  show,
  handleCloseModalCheck,
  isMobile,
}: {
  show?: boolean;
  handleCloseModalCheck: () => void;
  isMobile: boolean;
}) => {
  const [data, setData] = React.useState<any>(null);
  const [contactData, setContactData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(
      [PAGE_NAME.BASIC_INFORMATION, PAGE_NAME.CONTACT_DETAILS],
      reviewedAndComplete,
      setReviewedAndComplete
    );
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const [res, contactResponse, pageStatusResponse]: [any, any, any] = await Promise.all([
        basicInformationServices.getBasicDetail(params.id === ':id' ? null : params.id),
        basicInformationServices.getContact(params.id === ':id' ? null : params.id),
        pageStatusService.getPageStatusByPageName(
          params.id === ':id' ? null : params.id,
          PAGE_NAME.BASIC_INFORMATION
        ),
      ]);
      setData({ ...res, csu_info: checkEnableParseJSON(res?.csu_info) });
      setContactData(contactResponse);
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      {/* Personal Information Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Personal Information</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">First/given name*</div>
            <div className="gm-summary-field-value">{data?.first_name || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Middle name</div>
            <div className="gm-summary-field-value">{data?.middle_name || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Last/family/surname*</div>
            <div className="gm-summary-field-value">{data?.last_name || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Suffix</div>
            <div className="gm-summary-field-value">{data?.label || '-'}</div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Email*</div>
            <div className="gm-summary-field-value">{data?.email || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Email Address Type*</div>
            <div className="gm-summary-field-value">{data?.csu_info?.emailType || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Date of Birth*</div>
            <div className="gm-summary-field-value">{data?.dob || '-'}</div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Do you have a lived/preferred name?*</div>
            <div className="gm-summary-field-value">
              {formatBooleanToYesNo(data?.csu_info?.have_lived_name)}
            </div>
          </div>
        </div>

        {formatBoolean(data?.csu_info?.have_lived_name) && (
          <div className="gm-summary-conditional-section">
            <div className="gm-summary-conditional-title">Lived Name Information</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Lived first name*</div>
                <div className="gm-summary-field-value">
                  {data?.csu_info?.lived_first_name || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Lived middle name</div>
                <div className="gm-summary-field-value">
                  {data?.csu_info?.lived_middle_name || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Lived Last/family/surname*</div>
                <div className="gm-summary-field-value">
                  {data?.csu_info?.lived_last_name || '-'}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Have you ever had a different legal name?</div>
            <div className="gm-summary-field-value">
              {formatBooleanToYesNo(data?.is_have_legal_name)}
            </div>
          </div>
        </div>

        {data?.is_have_legal_name && (
          <div className="gm-summary-conditional-section">
            <div className="gm-summary-conditional-title">Former Legal Name Information</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Former First Name*</div>
                <div className="gm-summary-field-value">{data?.legal_first_name || '-'}</div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Former Middle Name</div>
                <div className="gm-summary-field-value">{data?.legal_middle_name || '-'}</div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Former Last Name*</div>
                <div className="gm-summary-field-value">{data?.legal_family_name || '-'}</div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Former Suffix</div>
                <div className="gm-summary-field-value">
                  {data?.legal_first_name_you_go_by || '-'}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Gender and Sexual Orientation Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Gender and Sexual Orientation</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Sex*</div>
            <div className="gm-summary-field-value">
              {buildSexValue(checkEnableParseJSON(data?.sex)) || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Legal sex*</div>
            <div className="gm-summary-field-value">{data?.csu_info?.legal_sex || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Pronouns</div>
            <div className="gm-summary-field-value">{buildSexValue(data, true) || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">How do you describe yourself?*</div>
            <div className="gm-summary-field-value">
              {getSexSelfDescribeValue(data?.sex_self_describe)}
            </div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">What do you consider to be?*</div>
            <div className="gm-summary-field-value">{data?.sex_self_consider || '-'}</div>
          </div>
        </div>

        {data?.sex_self_consider === 'Not listed above' && (
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Please describe</div>
              <div className="gm-summary-field-value">
                {capitalizeFirstLetter(data?.sex_self_consider_describe || '-')}
              </div>
            </div>
          </div>
        )}

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              How do you describe the way you express your gender identity in terms of behavior,
              appearance, speech, and movement?*
            </div>
            <div className="gm-summary-field-value">{data?.csu_info?.gender_identity || '-'}</div>
          </div>
        </div>

        {data?.csu_info?.gender_identity === 'None of the Above' && (
          <div className="gm-summary-conditional-section">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Another identity expression (please specify)*
              </div>
              <div className="gm-summary-field-value">
                {data?.csu_info?.another_gender_identity || '-'}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Address Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Address Information</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Address Line 1 (including Apartment or Suite Number)*
            </div>
            <div className="gm-summary-field-value">{data?.address_line_1 || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Address Line 2</div>
            <div className="gm-summary-field-value">{data?.address_line_2 || '-'}</div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">City*</div>
            <div className="gm-summary-field-value">{data?.city || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">State*</div>
            <div className="gm-summary-field-value">{data?.state || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              {data?.country === 'United States of America' ? 'County*' : 'County'}
            </div>
            <div className="gm-summary-field-value">{data?.csu_info?.address_county || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Country*</div>
            <div className="gm-summary-field-value">{data?.country || '-'}</div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              {data?.country === 'United States of America' ? 'Zip Code*' : 'Zip Code'}
            </div>
            <div className="gm-summary-field-value">{data?.zip_code || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Approximate date through which current address is valid
            </div>
            <div className="gm-summary-field-value">
              {formatDate(data?.csu_info?.approximate_date) || '-'}
            </div>
          </div>
        </div>

        <div className="gm-summary-checkbox-container">
          <div className="gm-summary-text-primary" style={{ marginBottom: '8px' }}>
            Is this your permanent address and where we should send mail?
          </div>
          <div className="gm-summary-field-label">
            UC's need your current mailing address to send mail correspondences about the admissions
            process*
          </div>
          <div style={{ marginTop: '8px' }}>
            <div className="gm-summary-text-dark">
              {formatBooleanToYesNo(data?.is_should_send_mail)}
            </div>
          </div>
        </div>

        <div className="gm-summary-checkbox-container">
          <div className="gm-summary-text-primary" style={{ marginBottom: '8px' }}>
            Do you have an alternate mailing address?
          </div>
          <div className="gm-summary-field-label">
            If you attend a boarding school or use a different mailing address
          </div>
          <div style={{ marginTop: '8px' }}>
            <div className="gm-summary-text-dark">
              {formatBooleanToYesNo(data?.is_have_alternate_address)}
            </div>
          </div>
        </div>

        {formatBoolean(data?.is_have_alternate_address) && (
          <div className="gm-summary-conditional-section">
            <div className="gm-summary-conditional-title">Mailing Address</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Address Line 1 (including Apartment or Suite Number)
                </div>
                <div className="gm-summary-field-value">
                  {(data?.alternate_address_line_1 ?? data?.address_line_1) || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Address Line 2</div>
                <div className="gm-summary-field-value">
                  {(data?.alternate_address_line_2 ?? data?.address_line_2) || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">City*</div>
                <div className="gm-summary-field-value">
                  {(data?.alternate_city ?? data?.city) || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">State*</div>
                <div className="gm-summary-field-value">
                  {(data?.alternate_state ?? data?.state) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Zip Code*</div>
                <div className="gm-summary-field-value">
                  {data?.alternate_zip_code ? data?.alternate_zip_code : data?.zip_code || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">County*</div>
                <div className="gm-summary-field-value">
                  {(data?.csu_info?.mailing_address_county
                    ? data?.csu_info?.mailing_address_county
                    : data?.csu_info?.address_county) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Is this a temporary address?</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(data?.is_temporary_address)}
                </div>
              </div>
            </div>

            {formatBoolean(data?.is_temporary_address) && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">From date</div>
                    <div className="gm-summary-field-value">{data?.temporary_from_date || '-'}</div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">To date</div>
                    <div className="gm-summary-field-value">{data?.temporary_to_date || '-'}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Contact Details Section */}
      {contactData && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">Contact Details</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Main Phone Number</div>
              <div className="gm-summary-field-value">{contactData?.phone_number || '-'}</div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">I have an international phone number</div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(contactData?.is_have_international_phone_number)}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Type of Number</div>
              <div className="gm-summary-field-value">{contactData?.phone_number_type || '-'}</div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Secondary Phone Number</div>
              <div className="gm-summary-field-value">
                {contactData?.alternative_phone_number || '-'}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">I have an international phone number</div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(contactData?.alternative_is_have_international_phone_number)}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Type of Number</div>
              <div className="gm-summary-field-value">
                {contactData?.alternative_phone_number_type || '-'}
              </div>
            </div>
          </div>

          <div key={1} className="gm-summary-checkbox-container">
            <div className="gm-summary-text-primary">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(contactData?.is_authorized_text_message_sent)
                    ? '#1890ff'
                    : '#d9d9d9',
                  fontWeight: formatBoolean(contactData?.is_authorized_text_message_sent)
                    ? 'bold'
                    : 'normal',
                }}
              >
                {formatBoolean(contactData?.is_authorized_text_message_sent) ? '✓' : '○'}
              </span>
              I authorize text messages (for example, reminders about application deadlines) to be
              sent to the above phone number and accept responsibility for any charges incurred.
            </div>
            <div style={{ marginTop: '8px' }}>
              <div className="gm-summary-text-dark">
                {formatBoolean(contactData?.is_authorized_text_message_sent)}
              </div>
            </div>
          </div>

          <div key={2} className="gm-summary-checkbox-container">
            <div className="gm-summary-text-primary">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(contactData?.is_agree_csu_term) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(contactData?.is_agree_csu_term) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(contactData?.is_agree_csu_term) ? '✓' : '○'}
              </span>
              I agree to the Terms of Service and to receive calls and/or texts at any phone number
              I have provided or may provide in the future, including any wireless number, from any
              entity associated with my application process, including but not limited to my
              designated schools and programs, the Liaison International support team, the
              association or institution for this Centralized Application Service.
            </div>
            <div style={{ marginTop: '8px' }}>
              <div className="gm-summary-text-dark">
                {formatBoolean(contactData?.is_agree_csu_term)}
              </div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Can we share your contact information with UC campus and programs?
              </div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(contactData?.is_allowed_share_contact)}
              </div>
            </div>
          </div>

          <div key={3} className="gm-summary-checkbox-container">
            <div className="gm-summary-text-primary">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(contactData?.is_allowed_share_contact)
                    ? '#1890ff'
                    : '#d9d9d9',
                  fontWeight: formatBoolean(contactData?.is_allowed_share_contact)
                    ? 'bold'
                    : 'normal',
                }}
              >
                {formatBoolean(contactData?.is_allowed_share_contact) ? '✓' : '○'}
              </span>
              I authorize the University of California to share my contact information.
            </div>
            <div style={{ marginTop: '8px' }}>
              <div className="gm-summary-text-dark">
                {formatBoolean(contactData?.is_allowed_share_contact)}
              </div>
            </div>
          </div>
        </div>
      )}

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input
              type="checkbox"
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #6c757d',
                borderRadius: '2px',
              }}
              checked={reviewedAndComplete}
              onClick={onReviewdAndComplete}
            />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}

      {/* {localStorage.getItem('userRole') === USER_ROLE.student && data && (
        <ModalCheckField
          show={show}
          onClose={handleCloseModalCheck}
          data={{ ...data, sex: checkEnableParseJSON(data?.sex), ...contactData }}
          page={'basic-information'}
        />
      )} */}
    </div>
  );
};

export const SummaryDemographics = ({ isMobile }: { isMobile: boolean }) => {
  const [demographicData, setDemographicData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.DEMOGRAPHICS, reviewedAndComplete, setReviewedAndComplete);
  };

  const handleCloseModalCheck = () => {
    setShow(false);
  };

  let best_group_describe_racial_background_array = tryParseJSON(
    demographicData?.best_group_describe_racial_background_array,
    {}
  );

  let value_consider_hispanic_latino = best_group_describe_racial_background_array
    ? best_group_describe_racial_background_array?.value_consider_hispanic_latino || '-'
    : '-';

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await basicInformationServices.getDemoGraphics(
        params.id === ':id' ? null : params.id
      );

      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.DEMOGRAPHICS
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setDemographicData({
        ...res,
        demographics_additional_data: checkEnableParseJSON(res?.demographics_additional_data),
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Demographics
        </Typography>
        <div>
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <Button variant="primary" className="p-2 px-3" onClick={() => setShow(true)}>
              Check missing values
            </Button>
          )} */}
        </div>
      </div>
      {demographicData && (
        <>
          {/* Demographics Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Demographics Information</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Check all that apply to you: *</div>
                <div className="gm-summary-field-value">
                  {militaryOptions.map((option, index) => {
                    const keyName = option.value;
                    return (
                      <div key={index} style={{ marginBottom: '8px' }}>
                        <CheckboxContent
                          label={option.label}
                          values={
                            checkEnableParseJSON(demographicData?.all_apply_array, {})[keyName]
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {demographicData.is_foster_care && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Are you a ward of the court or in foster care in California? *
                  </div>
                  <div className="gm-summary-field-value">
                    {demographicData?.demographics_additional_data?.isInFosterCare || '-'}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Military Affiliation Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Military Affiliation</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">U.S. Armed Forces Status</div>
                <div className="gm-summary-field-value">
                  {demographicData?.us_armed_forces_status || '-'}
                </div>
              </div>
            </div>

            {demographicData.us_armed_forces_status !== 'None' && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Are you a dependent of a U.S. military veteran or service member?
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(demographicData?.is_dependent_us_military)}
                  </div>
                </div>
              </div>
            )}

            {(demographicData.us_armed_forces_status === 'Currently Serving' ||
              demographicData.us_armed_forces_status === 'Previously Served') && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Military Experience</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Anticipated status at the time you enroll
                    </div>
                    <div className="gm-summary-field-value">
                      {demographicData.anticipated_status || '-'}
                    </div>
                  </div>
                </div>

                {demographicData.anticipated_status === 'On Active Duty' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Are you permanently stationed in California? *
                      </div>
                      <div className="gm-summary-field-value">
                        {formatBooleanToYesNo(
                          demographicData?.demographics_additional_data?.isPermanentlyStationed
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Number of Military experience you have
                    </div>
                    <div className="gm-summary-field-value">
                      {demographicData?.number_military_experience || '-'}
                    </div>
                  </div>
                </div>

                {(checkEnableParseJSON(demographicData?.military_experience_array) || []).map(
                  (item: any, index: number) => (
                    <div key={index} className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">Branch</div>
                        <div className="gm-summary-field-value">
                          {item?.branch +
                            ' (' +
                            renderDate(item.startDate) +
                            ' - ' +
                            renderDate(item.endDate) +
                            ')'}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}

            {demographicData?.us_armed_forces_status === 'Current Dependent' && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Current Dependent Information</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      What is the status of the person you are a dependent of who is currently
                      serving or has previously served?
                    </div>
                    <div className="gm-summary-field-value">
                      {demographicData?.demographics_additional_data
                        ?.statusOfPersonYouAreDependance || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Is the U.S. military service member on active duty? *
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBooleanToYesNo(
                        demographicData?.demographics_additional_data
                          ?.is_US_military_service_on_active_duty
                      )}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Is the U.S. military service member permanently stationed in California? *
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBooleanToYesNo(
                        demographicData?.demographics_additional_data
                          ?.is_US_military_service_permanently_stationed_in_California
                      )}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-checkbox-container">
                  <div className="gm-summary-text-primary">
                    <span
                      style={{
                        marginRight: '12px',
                        fontSize: '18px',
                        color: formatBoolean(
                          demographicData?.demographics_additional_data
                            ?.is_plan_to_submit_us_military_transcript
                        )
                          ? '#1890ff'
                          : '#d9d9d9',
                        fontWeight: formatBoolean(
                          demographicData?.demographics_additional_data
                            ?.is_plan_to_submit_us_military_transcript
                        )
                          ? 'bold'
                          : 'normal',
                      }}
                    >
                      {formatBoolean(
                        demographicData?.demographics_additional_data
                          ?.is_plan_to_submit_us_military_transcript
                      )
                        ? '✓'
                        : '○'}
                    </span>
                    Check if you plan to submit an official U.S. military transcript (AARTS, SMART,
                    JST or CGI)?
                  </div>
                  {/* <div style={{ marginTop: '8px' }}>
                    <div className="gm-summary-text-dark">
                      {formatBoolean(
                        demographicData?.demographics_additional_data
                          ?.is_plan_to_submit_us_military_transcript
                      )}
                    </div>
                  </div> */}
                </div>
              </div>
            )}
          </div>

          {/* Ethnicity Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Ethnicity</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Do you consider yourself Hispanic or Latino?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(demographicData?.is_consider_hispanic_latino) || '-'}
                </div>
              </div>
            </div>

            {formatBoolean(demographicData?.is_consider_hispanic_latino) && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Which best describes your Hispanic or Latino background?*
                  </div>
                  <div className="gm-summary-field-value">{value_consider_hispanic_latino}</div>
                </div>
              </div>
            )}

            {value_consider_hispanic_latino === 'Other Central American' && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Please specify Other Central American:*
                  </div>
                  <div className="gm-summary-field-value">
                    {best_group_describe_racial_background_array
                      ? best_group_describe_racial_background_array?.specify_is_Other_Central_American ||
                        '-'
                      : '-'}
                  </div>
                </div>
              </div>
            )}

            {value_consider_hispanic_latino === 'Other South American' && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Please specify Other South American:*
                  </div>
                  <div className="gm-summary-field-value">
                    {best_group_describe_racial_background_array
                      ? best_group_describe_racial_background_array?.specify_is_Other_South_American ||
                        '-'
                      : '-'}
                  </div>
                </div>
              </div>
            )}

            {value_consider_hispanic_latino === 'Other Hispanic or Latino' && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Please specify Other Hispanic or Latino:*
                  </div>
                  <div className="gm-summary-field-value">
                    {best_group_describe_racial_background_array
                      ? best_group_describe_racial_background_array?.specify_is_Other_Hispanic_or_Latino ||
                        '-'
                      : '-'}
                  </div>
                </div>
              </div>
            )}

            <EthnicitySum formValues={demographicData} />
          </div>

          {/* Language Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Language</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Number of languages you are proficient in*
                </div>
                <div className="gm-summary-field-value">
                  {demographicData?.number_language_proficient || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Proficiency Level</div>
                {checkEnableParseJSON(demographicData?.language_array, []).map((i: any) => {
                  let lang: string = buildLanguage(i) || '-';
                  return <div className="gm-summary-field-value">{lang}</div>;
                })}
              </div>
            </div>
          </div>

          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}

          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <ModalCheckField
              show={show}
              onClose={handleCloseModalCheck}
              data={{
                ...demographicData,
                all_apply_array: checkEnableParseJSON(demographicData?.all_apply_array),
                best_group_describe_racial_background_array: checkEnableParseJSON(
                  demographicData?.best_group_describe_racial_background_array
                ),
                best_group_latino_background_array: checkEnableParseJSON(
                  demographicData?.best_group_latino_background_array
                ),
                language_array: checkEnableParseJSON(demographicData?.language_array),
              }}
              page={'demographics'}
            />
          )} */}
        </>
      )}
    </div>
  );
};

const buildLanguage = (i: any) => {
  const proficiency = [
    i.isFirstLanguage ? 'First Language' : '',
    i.isSpeak ? 'Speak' : '',
    i.isRead ? 'Read' : '',
    i.isWrite ? 'Write' : '',
    i.isSpokenAtHome ? 'Spoken at Home' : '',
  ]
    .filter((i) => i !== '')
    .join(', ');

  let s1 = i.proficiencyLevel ? i.proficiencyLevel.replace('Select', '') : '';
  let s2 = proficiency?.length > 0 ? proficiency.replace('null', '') : '';

  if (s1.length > 0 && s2.length > 0) {
    return `${i.language} (${s1} - ${s2})`;
  } else if (s1.length > 0 && s2.length === 0) {
    return `${i.language} (${s1})`;
  } else if (s1.length === 0 && s2.length > 0) {
    return `${i.language} (${s2})`;
  }
  return `${i.language}`;
};
export const SummaryCitizenship = ({ isMobile }: { isMobile: boolean }) => {
  const [citizenshipData, setCitizenshipData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.CITIZENSHIP, reviewedAndComplete, setReviewedAndComplete);
  };

  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await basicInformationServices.getCitizenship(
        params.id === ':id' ? null : params.id
      );
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.CITIZENSHIP
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);

      setCitizenshipData({
        ...res,
        csu_info: checkEnableParseJSON(res?.csu_info),
        statement_legal_resident: checkEnableParseJSON(res?.statement_legal_resident),
        indicator_economic_fee_waiver_array: checkEnableParseJSON(
          res?.indicator_economic_fee_waiver_array
        ),
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Citizenship
        </Typography>
        <div>
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <Button variant="primary" className="p-2 px-3" onClick={() => setShow(true)}>
              Check missing values
            </Button>
          )} */}
        </div>
      </div>
      {citizenshipData && (
        <>
          {/* Citizenship Status Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Citizenship Status</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Citizenship status*</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.current_citizenship_status || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">List Citizenship(s)*</div>
                <div className="gm-summary-field-value">
                  {(checkEnableParseJSON(citizenshipData?.list_citizenship) || [])
                    .map((item: any) => item)
                    .join(', ') || '-'}
                </div>
              </div>
            </div>
          </div>

          {citizenshipData?.current_citizenship_status === 'U.S. citizen or U.S. national' && (
            <div className="gm-summary-section">
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Do you have or will you require an F1 Visa (student) or J1 Visa (exchange) to
                    study at the California State University (CSU)?*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(citizenshipData?.csu_info?.require_F1_Visa_or_J1_visa)}
                  </div>
                </div>
                {formatBoolean(citizenshipData?.csu_info?.require_F1_Visa_or_J1_visa) === true ? (
                  <>
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Which student visa do you have, or will you have when you study at the CSU?*
                      </div>
                      <div className="gm-summary-field-value">
                        {citizenshipData?.csu_info?.visa_you_have_at_CSU || '-'}
                      </div>
                    </div>
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Date Issued (if you have already been issued a student visa)
                      </div>
                      <div className="gm-summary-field-value">
                        {formatDate(citizenshipData?.csu_info?.visa_you_have_at_CSU_date_issued) ||
                          '-'}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      What U.S. State/Possession do you regard as your permanent home?*
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.us_state_you_regard_as_permanent_home || '-'}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* International Agent Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">International Agent</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you currently working with a representative or agency?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.current_working_with_representative_or_agency
                  ) || '-'}
                </div>
              </div>
            </div>

            {formatBoolean(
              citizenshipData?.csu_info?.current_working_with_representative_or_agency
            ) === true && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Representative Information</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Type*</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_type || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Name*</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_name || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Street Address</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_street_address || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Representative Street Address Line 2
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_street_address_line_2 || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative City</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_city || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative State/Province</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_state || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Postal Code</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_postal_code || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Country*</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_country || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Phone*</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_phone || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Representative Email*</div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.representative_email || '-'}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* International Applicant Details Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">International Applicant Details</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  What year did you (or do you plan to) move to the U.S.?*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.csu_info?.year_move_to_US || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  What is your main country of Citizenship ?*
                </div>
                <div className="gm-summary-field-value">{citizenshipData?.country || '-'}</div>
              </div>
            </div>

            {citizenshipData?.country !== 'United States of America' && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Non-U.S. Citizen Information</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      What will your citizenship status be on the date you submit this application?
                      *
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.citizenship_status || '-'}
                    </div>
                  </div>
                </div>

                {citizenshipData?.citizenship_status ===
                  'Legal U.S. permanent resident (green card)' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">Country of Citizenship</div>
                      <div className="gm-summary-field-value">
                        {citizenshipData?.csu_info?.country || '-'}
                      </div>
                    </div>
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Permanent Resident / Green Card Date Issued*
                      </div>
                      <div className="gm-summary-field-value">
                        {formatDate(citizenshipData?.csu_info?.date) || '-'}
                      </div>
                    </div>
                  </div>
                )}

                {citizenshipData?.citizenship_status === 'Refugee' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">Country of Citizenship*</div>
                      <div className="gm-summary-field-value">
                        {citizenshipData?.csu_info?.country || '-'}
                      </div>
                    </div>
                  </div>
                )}

                {citizenshipData?.citizenship_status ===
                  'Non-immigrant/foreign visa (you have a visa or will be applying for one)' && (
                  <div className="gm-summary-conditional-section">
                    <div className="gm-summary-conditional-title">Visa Information</div>
                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                          Do you currently have a U.S. visa? *
                        </div>
                        <div className="gm-summary-field-value">
                          {formatBooleanToYesNo(citizenshipData?.have_us_visa)}
                        </div>
                      </div>
                    </div>

                    {formatBoolean(citizenshipData?.have_us_visa) === true && (
                      <>
                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              Currently held United States Visa *
                            </div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.csu_info?.currently_held_united_states_visa || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Current visa type *</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.type_of_current_us_visa || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Visa Type</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.csu_info?.visa_type || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Visa number *</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.csu_info?.visa_number || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Date Issued *</div>
                            <div className="gm-summary-field-value">
                              {formatDate(citizenshipData?.csu_info?.date_issued) || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item"></div>
                        </div>
                      </>
                    )}
                    {formatBoolean(citizenshipData?.have_us_visa) === false && (
                      <div className="gm-summary-field-grid">
                        <div className="gm-summary-field-item">
                          <div className="gm-summary-field-label">
                            Which type of U.S. visa will you apply for (or have applied for)? *
                          </div>
                          <div className="gm-summary-field-value">
                            {citizenshipData?.type_of_apply_for_us_visa || '-'}
                          </div>
                        </div>
                        <div className="gm-summary-field-item">
                          <div className="gm-summary-field-label">Country of Citizenship</div>
                          <div className="gm-summary-field-value">
                            {citizenshipData?.csu_info?.country || '-'}
                          </div>
                        </div>
                      </div>
                    )}

                    {formatBoolean(citizenshipData?.have_us_visa) === true && (
                      <>
                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Current visa type *</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.type_of_current_us_visa || '-'}
                            </div>
                          </div>
                        </div>

                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              Do you have or will you require an F1 Visa (student) or J1 Visa
                              (exchange) to study at the California State University (CSU)?*
                            </div>
                            <div className="gm-summary-field-value">
                              {formatBooleanToYesNo(
                                citizenshipData?.csu_info?.require_F1_Visa_or_J1_visa
                              )}
                            </div>
                          </div>
                        </div>

                        {formatBoolean(citizenshipData?.csu_info?.require_F1_Visa_or_J1_visa) ===
                        true ? (
                          <div className="gm-summary-field-grid">
                            <div className="gm-summary-field-item">
                              <div className="gm-summary-field-label">
                                Which student visa do you have, or will you have when you study at
                                the CSU?*
                              </div>
                              <div className="gm-summary-field-value">
                                {citizenshipData?.csu_info?.visa_you_have_at_CSU || '-'}
                              </div>
                            </div>
                            <div className="gm-summary-field-item">
                              <div className="gm-summary-field-label">
                                Date Issued (if you have already been issued a student visa)
                              </div>
                              <div className="gm-summary-field-value">
                                {formatDate(
                                  citizenshipData?.csu_info?.visa_you_have_at_CSU_date_issued
                                ) || '-'}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="gm-summary-field-grid">
                            <div className="gm-summary-field-item">
                              <div className="gm-summary-field-label">
                                What U.S. State/Possession do you regard as your permanent home?*
                              </div>
                              <div className="gm-summary-field-value">
                                {citizenshipData?.csu_info?.us_state_you_regard_as_permanent_home ||
                                  '-'}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Visa Date Issued</div>
                            <div className="gm-summary-field-value">
                              {formatDate(citizenshipData?.csu_info?.visa_date_issued) || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              By the time you attend UC, will you have a different visa?*
                            </div>
                            <div className="gm-summary-field-value">
                              {formatBooleanToYesNo(citizenshipData?.will_you_have_different_visa)}
                            </div>
                          </div>
                        </div>

                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Planned visa type *</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.planned_visa_type || '-'}
                            </div>
                          </div>
                        </div>

                        {formatBoolean(citizenshipData?.will_you_have_different_visa) === false && (
                          <div className="gm-summary-field-grid">
                            <div className="gm-summary-field-item">
                              <div className="gm-summary-field-label">Visa Type</div>
                              <div className="gm-summary-field-value">
                                {citizenshipData?.csu_info?.other_visa_type || '-'}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Social Security Number Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Social Security Number</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Do you have a U.S. Social Security number or an Individual Taxpayer Identification
                  Number (ITIN)?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.is_have_us_social_security_number)}
                </div>
              </div>
            </div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              To protect your privacy, we do not ask for your social security number, however you'll
              need to input this information directly on the application when it is requested.
            </div>
          </div>

          {/* Birthplace Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Birthplace</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Country / Region / Territory*</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.country_birthplace || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Number of years you have lived in the United States*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.number_of_year_in_us || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">City of birth*</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.city_birthplace || '-'}
                </div>
              </div>
              {citizenshipData?.country_birthplace === 'United States of America' && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">State*</div>
                  <div className="gm-summary-field-value">
                    {citizenshipData?.state_birthplace || '-'}
                  </div>
                </div>
              )}
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you lived in California continuously since birth?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.statement_legal_resident
                      ?.have_lived_in_California_continuously_since_birth
                  ) || '-'}
                </div>
              </div>
            </div>

            {citizenshipData?.statement_legal_resident
              ?.have_lived_in_California_continuously_since_birth === 'false' && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    When did your present stay in California begin?*
                  </div>
                  <div className="gm-summary-field-value">
                    {renderDate(
                      citizenshipData?.statement_legal_resident
                        ?.when_your_present_stay_in_California_begin
                    ) || '-'}
                  </div>
                </div>
              </div>
            )}

            {citizenshipData?.country_birthplace !== 'United States of America' && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">
                  Years inside and outside the United States
                </div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      If you were born outside of the U.S., what year did you or will you move to
                      the U.S.*
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.year_move_to_us || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Number of years you have lived outside the United States*
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.number_of_year_outside_us || '-'}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* California Residency Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              California Residency for Admission Purposes
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  By the time you attend UC, will you have graduated from a California high school?
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.is_graduated_california_high_school) ||
                    '-'}
                </div>
              </div>
            </div>

            {formatBoolean(citizenshipData?.is_graduated_california_high_school) === true && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    By the time you attend UC, will you have attended a California school for three
                    or more years during grades K through 12?
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(
                      citizenshipData?.is_three_or_more_year_graduated_california_high_school
                    ) || '-'}
                  </div>
                </div>
              </div>
            )}

            {formatBoolean(
              citizenshipData?.is_three_or_more_year_graduated_california_high_school
            ) === false && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">California Residency Details</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Are you currently living in California?*
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBooleanToYesNo(citizenshipData?.is_currently_live_california) || '-'}
                    </div>
                  </div>
                </div>

                {formatBoolean(citizenshipData?.is_currently_live_california) === true && (
                  <>
                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                          Have you lived in California your entire life?*
                        </div>
                        <div className="gm-summary-field-value">
                          {formatBooleanToYesNo(citizenshipData?.is_live_california_entire_life) ||
                            '-'}
                        </div>
                      </div>
                    </div>

                    {formatBoolean(citizenshipData?.is_live_california_entire_life) === false && (
                      <div className="gm-summary-field-grid">
                        <div className="gm-summary-field-item">
                          <div className="gm-summary-field-label">
                            When did your present stay in California begin?
                          </div>
                          <div className="gm-summary-field-value">
                            {citizenshipData?.statement_legal_resident
                              ?.when_your_present_stay_in_California_begin || '-'}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
                      I have lived here since:
                    </div>

                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">Month</div>
                        <div className="gm-summary-field-value">
                          {citizenshipData?.month_live_here_since || '-'}
                        </div>
                      </div>
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">Year</div>
                        <div className="gm-summary-field-value">
                          {citizenshipData?.year_live_here_since === 0
                            ? '-'
                            : citizenshipData?.year_live_here_since || '-'}
                        </div>
                      </div>
                    </div>

                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                          Is one of your parents or legal guardians a permanent resident of
                          California?*
                        </div>
                        <div className="gm-summary-field-value">
                          {formatBooleanToYesNo(
                            citizenshipData?.is_one_of_parent_permanent_resident_california
                          ) || '-'}
                        </div>
                      </div>
                    </div>

                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                          Is your parent, legal guardian, spouse or registered domestic partner an
                          employee of the University of California or a UC-affiliated national
                          laboratory (Los Alamos National Security LLC or Lawrence Livermore
                          National Security LLC)?*
                        </div>
                        <div className="gm-summary-field-value">
                          {formatBooleanToYesNo(
                            citizenshipData?.is_parent_employee_university_california
                          ) || '-'}
                        </div>
                      </div>
                    </div>

                    {formatBoolean(
                      citizenshipData?.is_one_of_parent_permanent_resident_california
                    ) === true && (
                      <>
                        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
                          When did your parent or legal guardian become a permanent resident of
                          California? *
                        </div>
                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Month</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.month_parent_become_permanent_residence || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">Year</div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.year_parent_become_permanent_residence === 0
                                ? '-'
                                : citizenshipData?.year_parent_become_permanent_residence || '-'}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {formatBoolean(
                      citizenshipData?.is_one_of_parent_permanent_resident_california
                    ) === false && (
                      <div className="gm-summary-field-grid">
                        <div className="gm-summary-field-item">
                          <div className="gm-summary-field-label">
                            Which U.S State/possession does your parent/guardian regard as her
                            permanent home ?
                          </div>
                          <div className="gm-summary-field-value">
                            {citizenshipData?.csu_info?.state_your_parent_as_her_permanent_home ||
                              '-'}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>

          {/* Statement of Legal Residence Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Statement of Legal Residence</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Would you like to be evaluated for California residency for tuition purposes? *
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.statement_legal_resident
                      ?.is_like_to_be_evaluated_for_tuition_purposes
                  ) || '-'}
                </div>
              </div>
            </div>

            {formatBoolean(
              citizenshipData?.statement_legal_resident
                ?.is_like_to_be_evaluated_for_tuition_purposes
            ) === true && (
              <div className="gm-summary-conditional-section my-16">
                <div className="gm-summary-conditional-title">Residency Evaluation Details</div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Have you been physically present in California for the last 3 years? *
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBooleanToYesNo(
                        citizenshipData?.statement_legal_resident?.is_physically_present_for_3_years
                      ) || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Did you attend high school in California for three or more years, and will you
                      graduate or have you graduated from a high school in California? *
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBooleanToYesNo(
                        citizenshipData?.statement_legal_resident
                          ?.is_attend_highschool_for_3_more_years
                      ) || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Have you and your parents established California as your permanent home for
                      the past 366 days or more? *
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.statement_legal_resident
                        ?.is_established_as_permanent_home || '-'}
                    </div>
                  </div>
                </div>

                {citizenshipData?.statement_legal_resident?.is_established_as_permanent_home !==
                  'I do not consider myself a dependent upon my parents' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Are your parents married to each other?
                      </div>
                      <div className="gm-summary-field-value">
                        {citizenshipData?.statement_legal_resident
                          ?.is_parent_1_married_to_parent_2 || '-'}
                      </div>
                    </div>
                  </div>
                )}

                {citizenshipData?.statement_legal_resident?.is_parent_1_married_to_parent_2 ===
                  'No' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">Do your parents live together? *</div>
                      <div className="gm-summary-field-value">
                        {citizenshipData?.statement_legal_resident?.is_parents_live_together || '-'}
                      </div>
                    </div>
                  </div>
                )}

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Has Parent 1 been physically present in California for the last 3 years? *
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.statement_legal_resident?.is_parent_1_physically_present ||
                        '-'}
                    </div>
                  </div>
                </div>

                {citizenshipData?.statement_legal_resident?.is_parent_1_physically_present &&
                  citizenshipData?.statement_legal_resident?.is_parent_1_physically_present !==
                    'My Parent is Deceased' && (
                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">Is Parent 1 a U.S. Citizen? *</div>
                        <div className="gm-summary-field-value">
                          {citizenshipData?.statement_legal_resident?.is_parent_1_US_citizen || '-'}
                        </div>
                      </div>
                    </div>
                  )}

                {!(
                  citizenshipData?.statement_legal_resident?.is_parent_1_married_to_parent_2 ===
                    'No' &&
                  citizenshipData?.statement_legal_resident?.is_parents_live_together === 'No'
                ) && (
                  <>
                    <div className="gm-summary-field-grid">
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                          Has Parent 2 been physically present in California for the last 3 years? *
                        </div>
                        <div className="gm-summary-field-value">
                          {citizenshipData?.statement_legal_resident
                            ?.is_parent_2_physically_present || '-'}
                        </div>
                      </div>
                    </div>

                    {citizenshipData?.statement_legal_resident?.is_parent_2_physically_present &&
                      citizenshipData?.statement_legal_resident?.is_parent_2_physically_present !==
                        'My Parent is Deceased' && (
                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              Is Parent 2 a U.S. Citizen? *
                            </div>
                            <div className="gm-summary-field-value">
                              {citizenshipData?.statement_legal_resident?.is_parent_2_US_citizen ||
                                '-'}
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}
              </div>
            )}

            <div className="gm-summary-checkbox-container my-16">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(
                      citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                    )
                      ? '#1890ff'
                      : '#d9d9d9',
                    fontWeight: formatBoolean(
                      citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                    )
                      ? 'bold'
                      : 'normal',
                  }}
                >
                  {formatBoolean(
                    citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                  )
                    ? '✓'
                    : '○'}
                </span>
                I declare under penalty of perjury under the laws governing the State of California
                that the statements I have provided on this Statement of Legal Residence are, and
                each of them is, true and correct.
              </div>
            </div>

            <div className="gm-summary-checkbox-container my-16">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(
                      citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                    )
                      ? '#1890ff'
                      : '#d9d9d9',
                    fontWeight: formatBoolean(
                      citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                    )
                      ? 'bold'
                      : 'normal',
                  }}
                >
                  {formatBoolean(
                    citizenshipData?.statement_legal_resident?.is_declare_under_penalty_of_perjury
                  )
                    ? '✓'
                    : '○'}
                </span>
                I understand that as part of the process to issue a Residency Classification, I may
                be asked to submit additional documentation or information to a University of
                California Residence Deputy to supplement my Statement of Legal Residence. Failure
                to provide the requested information in a timely manner can affect my residence
                classification. Further, I understand that completion of the Statement of Legal
                Residence does not guarantee a Resident Classification for UC tuition.
              </div>
            </div>
          </div>

          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <ModalCheckField
              show={show}
              onClose={handleCloseModalCheck}
              data={{
                ...citizenshipData,
                answer_coalition_colleges_array: checkEnableParseJSON(
                  citizenshipData?.answer_coalition_colleges_array
                ),
                cbo_info_array: checkEnableParseJSON(citizenshipData?.cbo_info_array),
                list_citizenship: checkEnableParseJSON(citizenshipData?.list_citizenship),
              }}
              page={'citizenship'}
            />
          )} */}
        </>
      )}
    </div>
  );
};

export const SummaryCBO = ({ isMobile }: { isMobile: boolean }) => {
  const [citizenshipData, setCitizenshipData] = React.useState<any>(null);
  const [EducationalPrograms, setEducationalPrograms] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const dispatch = useAppDispatch();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.CBO, reviewedAndComplete, setReviewedAndComplete);
  };
  const handleCloseModalCheck = () => {
    setShow(false);
  };
  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await basicInformationServices.getCitizenship(
        params.id === ':id' ? null : params.id
      );

      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.CBO
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);

      setCitizenshipData({
        ...res,
        csu_info: checkEnableParseJSON(res?.csu_info),
        statement_legal_resident: checkEnableParseJSON(res?.statement_legal_resident),
        indicator_economic_fee_waiver_array: checkEnableParseJSON(
          res?.indicator_economic_fee_waiver_array
        ),
      });
      setLoading(false);
    };
    const getEducationalPrograms = async () => {
      try {
        setLoading(true);
        let studentId = params.id === ':id' ? null : params.id;
        let res = await dispatch(getEducationalProgram(studentId)).unwrap();
        const dataLoaded: any = res; // res.payload;
        if (dataLoaded) {
          const values: any = checkEnableParseJSON(dataLoaded.csu_info);
          setEducationalPrograms(values);
        }
      } catch (ex) {
        console.log('Error: ', ex);
      }
      setLoading(false);
    };
    if (params.id !== ':id') {
      getData();
      getEducationalPrograms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Educational Programs Participation
        </Typography>
        <div>
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <Button variant="primary" className="p-2 px-3" onClick={() => setShow(true)}>
              Check missing values
            </Button>
          )} */}
        </div>
      </div>
      {citizenshipData && (
        <>
          {/* Educational Programs Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Educational Programs Participation</div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              Have you participated in any of these programs in high school and beyond?
            </div>

            {/* AVID Program */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">AVID</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.avid) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.avid) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in AVID during High School:*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(EducationalPrograms?.year_participated_in_AVID) || '-'}
                  </div>
                </div>
              )}
            </div>

            {/* Upward Bound Program */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Upward Bound</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.upward_bound) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.upward_bound) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in Upward Bound during High School:*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(EducationalPrograms?.year_participated_in_upward_bound) ||
                      '-'}
                  </div>
                </div>
              )}
            </div>

            {/* Talent Search Program */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Talent Search or Educational Opportunity Center (EOC)
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.talent_search) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.talent_search) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in Talent Search or Educational Opportunity
                    Center (EOC) during high school*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(
                      EducationalPrograms?.year_participated_in_talent_search
                    ) || '-'}
                  </div>
                </div>
              )}
            </div>

            {/* Puente Project */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Puente Project</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.puente_project) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.puente_project) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in Puente Project*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(
                      EducationalPrograms?.year_participated_in_puente_project
                    ) || '-'}
                  </div>
                </div>
              )}
            </div>

            {/* Independent Living Project */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Independent Living Project (ILP)*</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.ilp) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.ilp) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in Independent Living Project (ILP)*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(EducationalPrograms?.year_participated_in_ilp) || '-'}
                  </div>
                </div>
              )}
            </div>

            {/* MESA Project */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">MESA Project</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.MESA_project) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.MESA_project) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in MESA Project*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(EducationalPrograms?.year_participated_in_MESA_project) ||
                      '-'}
                  </div>
                </div>
              )}
            </div>

            {/* Other Programs */}
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Other (CAMP, EAOP, EOP&S/CARE GEAR-UP, TRIO, or Foster youth support programs)
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(EducationalPrograms?.other_program) || '-'}
                </div>
              </div>
              {formatBoolean(EducationalPrograms?.other_program) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Number of years you participated in Gear-up, CAMP, Foster youth support
                    programs, Student Support Services Programs (SSSP)*
                  </div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(
                      EducationalPrograms?.year_participated_in_other_program
                    ) || '-'}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* CBOs Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Community-Based Organizations (CBOs)</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you participating in a Community-Based Organization (CBO)?
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.is_participate_cbo) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Indicate the number of community programs or organizations that have provided you
                  with free assistance in your application process.*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.indicate_number_community_programs || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Your CBOs</div>
                <div className="gm-summary-field-value">
                  {(checkEnableParseJSON(citizenshipData?.cbo_info_array) || [])
                    .map((e: any) => e?.organization ?? e?.otherOrganization)
                    .join(', ') || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* CBO Counselor Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">CBO Counselor / Advisor / Mentor</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Prefix</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.advisor_prefix || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">First Name</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.advisor_first_name || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Last Name</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.advisor_last_name || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Phone number</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.advisor_phone_number || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Email</div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.advisor_email || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Fee Waiver Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Fee Waiver</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Do you meet one or more of the Common App fee waiver, Opens in new tab,
                  eligibility criteria?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.is_financial_qualify_fee_waiver) || '-'}
                </div>
              </div>
            </div>

            {formatBoolean(citizenshipData?.is_financial_qualify_fee_waiver) === true && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    I certify that I understand and meet the eligibility requirements to request an
                    admission application fee waiver. I also understand if I am a first year student
                    my counselor will be asked to verify my eligibility. Fee Waiver signature *
                  </div>
                  <div className="gm-summary-field-value">
                    {citizenshipData?.fee_waiver_signature || '-'}
                  </div>
                </div>
              </div>
            )}

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Would you like to connect with a UStrive mentor?
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.indicator_economic_fee_waiver_array
                      ?.is_like_to_receive_information_from_strive_for_college
                  ) || '-'}
                </div>
              </div>
            </div>
          </div>

          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
          {/* <ModalCheckField
            show={show}
            onClose={handleCloseModalCheck}
            data={{
              ...citizenshipData,
              ...EducationalPrograms,
              answer_coalition_colleges_array: checkEnableParseJSON(
                citizenshipData?.answer_coalition_colleges_array
              ),
              cbo_info_array: checkEnableParseJSON(citizenshipData?.cbo_info_array),
              list_citizenship: checkEnableParseJSON(citizenshipData?.list_citizenship),
            }}
            page={'cbo'}
          /> */}
        </>
      )}
    </div>
  );
};

export const SummaryOther = ({ isMobile }: { isMobile: boolean }) => {
  const [citizenshipData, setCitizenshipData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.OTHER, reviewedAndComplete, setReviewedAndComplete);
  };

  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await basicInformationServices.getCitizenship(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.OTHER
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);

      setCitizenshipData({
        ...res,
        csu_info: checkEnableParseJSON(res?.csu_info),
        statement_legal_resident: checkEnableParseJSON(res?.statement_legal_resident),
        indicator_economic_fee_waiver_array: checkEnableParseJSON(
          res?.indicator_economic_fee_waiver_array
        ),
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Other Information
        </Typography>
        <div>
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <Button variant="primary" className="p-2 px-3" onClick={() => setShow(true)}>
              Check missing values
            </Button>
          )} */}
        </div>
      </div>
      {citizenshipData && (
        <>
          {/* CSU Release Statements Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">CSU Release Statements</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-title">
                  CERTIFICATION - to be read and authorized by all applicants to certify the
                  accuracy of the information provided.
                </div>
                <div className="gm-summary-field-value">
                  <div className="gm-summary-field-label">
                    I certify under penalty of perjury under the laws of the State of California
                    that I have provided complete and accurate responses to all the items on this
                    application. I further certify that all official documents submitted in support
                    of this application are authentic and unaltered records that pertain to me. I
                    authorize the California State University to release any information submitted
                    by me in this application for admission and any application for financial aid to
                    any person, firm, corporation, association, or government agency to verify or
                    explain the information I have provided or to obtain other information necessary
                    for my application for admission and any application for administration of
                    financial aid and in connection with any perjury proceedings. I authorize the
                    California State University system to release any submitted test results to all
                    campuses to which I submit an application. My certification verifies the
                    accuracy and completeness of the information provided. I understand that any
                    misrepresentation or omission may be cause for denial or cancellation of
                    admission, transfer credit, or enrollment. I certify that so long as I am a
                    student at this institution, I will advise the residence clerk if there is a
                    change in any of the facts affecting my residence.
                  </div>
                </div>
              </div>
            </div>

            <div className="gm-summary-checkbox-container">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(citizenshipData?.csu_info?.is_certify)
                      ? '#1890ff'
                      : '#d9d9d9',
                    fontWeight: formatBoolean(citizenshipData?.csu_info?.is_certify)
                      ? 'bold'
                      : 'normal',
                  }}
                >
                  {formatBoolean(citizenshipData?.csu_info?.is_certify) ? '✓' : '○'}
                </span>
                Your certification of this statement serves the same purpose as a legal signature,
                and is binding.*
              </div>
            </div>
          </div>

          {/* CAASPP Results Release Statement Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">CAASPP Results Release Statement</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  I hereby authorize the California Department of Education to release my California
                  Assessment of Student Performance and Progress (CAASPP) score report to the
                  California State University for the purpose of credit, placement, or determination
                  of readiness for college-level coursework.
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.csu_info?.hereby_authorize_CD_release_CAASPP || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Release of Contact Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Release of Contact Information</div>
            <div className="gm-summary-checkbox-container">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(
                      citizenshipData?.csu_info?.is_authorize_CSU_release_contact_information
                    )
                      ? '#1890ff'
                      : '#d9d9d9',
                    fontWeight: formatBoolean(
                      citizenshipData?.csu_info?.is_authorize_CSU_release_contact_information
                    )
                      ? 'bold'
                      : 'normal',
                  }}
                >
                  {formatBoolean(
                    citizenshipData?.csu_info?.is_authorize_CSU_release_contact_information
                  )
                    ? '✓'
                    : '○'}
                </span>
                Check the box to acknowledge the above statement.
              </div>
            </div>
          </div>

          {/* Additional Information Release Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Additional Information Release</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  I authorize the California State University to release to my school or college
                  counselor/counseling office information regarding my application, including test
                  scores, transcripts, and other supporting documents, as they relate to my admission
                  status. If you opt out, the CSU may not inform your school or counselor whether you
                  have applied or been admitted.*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.csu_info?.is_authorize_CSU_release_my_application === true
                    ? 'Yes'
                    : citizenshipData?.csu_info?.is_authorize_CSU_release_my_application === false
                      ? 'Opt Out'
                      : citizenshipData?.csu_info?.is_authorize_CSU_release_my_application || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Campus Housing Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Campus Housing</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you interested in on campus housing should space be available? Note: housing
                  availability is subject to your submission of a separate campus housing
                  application and availability.*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.is_interested_on_campus_space_available
                  ) || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Applicant Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Applicant Information</div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              These questions will help campuses determine services that may be available.
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  At any time since you turned age 13, were both your parents deceased, were you in
                  foster care, or were you a dependent or ward of the court?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.csu_info?.in_foster_care) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  As determined by a court in your state of legal residence, are you or were you an
                  emancipated minor?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.csu_info?.is_emancipated_minor) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  At any time on or after July 1, 2026, did your high school or school district
                  homeless liaison determine that you were an unaccompanied youth who was homeless
                  or were self-supporting and at risk of being homeless?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.csu_info?.is_homeless_liaison_determine) ||
                    '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  At any time on or after July 1, 2026, did the director of an emergency shelter or
                  transitional housing program funded by the U.S. Department of Housing and Urban
                  Development determine that you were an unaccompanied youth who was homeless or
                  were self-supporting and at risk of being homeless?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.is_director_or_transitional_determine
                  ) || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  At any time on or after July 1, 2026, did the director of a runaway or homeless
                  youth basic center or transitional living program determine that you were an
                  unaccompanied youth who was homeless or were self-supporting and at risk of being
                  homeless?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.is_director_of_runaway_or_homeless_youth_basic
                  ) || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Statewide Student ID Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Statewide Student ID</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you ever attended a California public school?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.attended_California_public_school
                  ) || '-'}
                </div>
              </div>
            </div>

            {formatBoolean(citizenshipData?.csu_info?.attended_California_public_school) ===
              true && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">
                  California Public School Information
                </div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      California Statewide Student Identifier (SSID)
                    </div>
                    <div className="gm-summary-field-value">
                      {citizenshipData?.csu_info?.ssid || '-'}
                    </div>
                  </div>
                </div>

                <div className="gm-summary-checkbox-container">
                  <div className="gm-summary-text-primary">
                    I authorize the release of my CA SSID Number and application status to
                    California Guidance College Initiative (CCGI) for the purpose of tracking my UC
                    application. I understand that the information will only be shared if my school
                    has provided my transcript to CCGI.
                  </div>
                  <div style={{ marginTop: '8px' }}>
                    <div className="gm-summary-text-dark">
                      {formatBooleanToYesNo(
                        citizenshipData?.csu_info
                          ?.authorize_release_CASSID_for_tracking_UC_application
                      ) || '-'}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Academic Standing Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Academic Standing</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you in good standing with your last school attended?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.csu_info?.is_in_good_standing) || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Academic Infractions and Conduct Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Academic Infractions and Conduct</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you ever been disciplined for academic performance (e.g. academic probation,
                  disqualification, etc.) by any college or university?
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(citizenshipData?.csu_info?.is_disciplined_for_academic_performance)
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you been academically disqualified at any college or university?
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(citizenshipData?.csu_info?.is_academically_disqualified)
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you ever been disciplined for student conduct violations (e.g. suspension,
                  expulsion, etc.) by any college or university?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(
                    citizenshipData?.csu_info?.is_disciplined_for_student_conduct_violations
                  )
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>
          </div>

          {/* Teacher or Other Education Credential Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Teacher or Other Education Credential Information
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Select your interest in obtaining your teacher or other educational credential.*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.csu_info?.interest_in_teacher_or_educational_credential || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* CalFresh Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">CalFresh</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you interested in checking your eligibility for monthly food assistance to be
                  used towards groceries through the CalFresh Program?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.is_interested_eligibility_assistance_CalFresh
                  ) || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Finish in Four and Through in Two Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Finish in Four and Through in Two
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you interested in participating in the Finish in Four and Through in Two?
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(
                    citizenshipData?.csu_info?.is_interested_participating_CA_Promise
                  ) || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* RN License Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">RN License</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Do you have an RN (registered nurse) license or expect to achieve a RN license?*
                </div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(citizenshipData?.csu_info?.have_rn_license) || '-'}
                </div>
              </div>
              {formatBoolean(citizenshipData?.csu_info?.have_rn_license) === true && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">RN License*</div>
                  <div className="gm-summary-field-value">
                    {citizenshipData?.csu_info?.rn_license || '-'}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* How did you Hear About Us Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">How did you Hear About Us?</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  How did you hear about CalState.edu/apply?*
                </div>
                <div className="gm-summary-field-value">
                  {citizenshipData?.csu_info?.how_hear_about_CalState || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* UC Release Statements Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">UC Release Statements</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Community principles</div>
                <div className="gm-summary-field-value">
                  <div className="gm-summary-field-label">
                    We are a community of people from diverse backgrounds, with diverse identities,
                    abilities, and needs. Everything we do is supported and enriched by an
                    atmosphere of positive engagement and a spirit of cooperation and inquiry.
                    <br />
                    Each UC campus has committed to Principles of Community that reaffirm each
                    individual's right to dignity and civil discourse. We ask you to agree that, if
                    you become part of the UC community, you will seek to maintain a climate of
                    civility and mutual respect.
                    <br />
                    The following principles serve as a guide and reflect our passion for critical
                    inquiry and our deep commitment to contributing to a better world:
                    <br />
                    — We place honesty and integrity in our teaching, learning, research and
                    administration at the highest level.
                    <br />
                    — We respect the differences as well as the commonalities that bring us
                    together.
                    <br />
                    — We reject acts of discrimination based on race, ethnicity, sex, gender
                    identity, age, disability, sexual orientation, religion, and political beliefs.
                    <br />— We are committed to ensuring freedom of expression. We celebrate the
                    expression of individuality and diversity within the bounds of courtesy,
                    sensitivity, and respect.
                  </div>
                </div>
              </div>
            </div>

            <div className="gm-summary-checkbox-container">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(citizenshipData?.csu_info?.agree_with_guiding_principles)
                      ? '#1890ff'
                      : '#d9d9d9',
                    fontWeight: formatBoolean(
                      citizenshipData?.csu_info?.agree_with_guiding_principles
                    )
                      ? 'bold'
                      : 'normal',
                  }}
                >
                  {formatBoolean(citizenshipData?.csu_info?.agree_with_guiding_principles)
                    ? '✓'
                    : '○'}
                </span>
                I acknowledge, value, and agree with these guiding principles.*
              </div>
            </div>
          </div>

          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <ModalCheckField
              show={show}
              onClose={handleCloseModalCheck}
              data={citizenshipData}
              page={'other'}
            />
          )} */}
        </>
      )}
    </div>
  );
};
